<template>
  <v-row justify="center">
    <!-- tarjeta enlace para compartir -->
    <v-col cols="8">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Programa de referidos</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items v-if="program.is_partner === true">
            <v-row align="center" justify="center" class="mr-1">
              <v-tooltip color="primary" left max-width="280px" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" color="primary" small text-color="white">Partner</v-chip>
                </template>
                <span class="white--text">Eres partner, por lo que tienes una bonificación preferencial en tus recompensas por cada referido.</span>
              </v-tooltip>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <h2 class="heading-3 text--secondary font-weight-medium">Gana contándole al mundo sobre Piriod</h2>
              <span class="mt-2 d-block body-2 text--primary mb-1">Comparte tu enlace y gana {{ rewardLabel }} en crédito por cada organización que se registre.</span>

              <v-divider class="my-4" />

              <span class="mt-4 d-block body-1 text--secondary font-weight-medium">Copia y comparte tu enlace único de referidos</span>
              <v-text-field class="ml-n1" :value="program.share_link" :loading="programLoader" placeholder="Generando tu enlace..." background-color="white" outlined readonly single-line dense hide-details @click="copyLink">
                <template v-slot:append>
                  <v-btn class="px-3" :disabled="!program.share_link" @click="copyLink" height="18" text color="primary" :ripple="false">Copiar<v-icon right>mdi-content-copy</v-icon></v-btn>
                </template>
              </v-text-field>

              <v-divider class="mt-4 mb-10" />

              <span class="d-block body-1 text--secondary font-weight-medium">Organización beneficiaria</span>
              <span class="d-block body-2 text--primary mb-1">Elige la organización que recibirá las recompensas.</span>
              <v-select class="ml-n1" v-model="selectedBeneficiary" :items="accountsList" item-text="name" item-value="id" :loading="beneficiaryLoader" :disabled="beneficiaryLoader || !program.referral_code" @change="changeBeneficiary" background-color="white" outlined single-line dense hide-details placeholder="Selecciona una organización" />
            </v-col>
            <v-col cols="6">
              <v-card class="pa-4" outlined>
                <v-list class="transparent py-0">
                  <v-list-item v-for="(step, index) in steps" :key="index" class="px-0">
                    <v-list-item-avatar class="mr-4" color="primary" size="32">
                      <span class="white--text body-2 font-weight-medium">{{ index + 1 }}</span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">{{ step.title }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2 text--primary no-ellipsis">{{ step.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- tarjeta organizaciones referidas -->
    <v-col cols="8">
      <v-card class="px-0">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Organizaciones referidas</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-skeleton-loader v-if="$store.state.referrals.retrieveLoader" transition="fade-transition" type="table" />
          <template v-else>
            <v-col v-if="!referralsList.length" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-account-multiple-plus</v-icon>
              <span class="d-block subtitle-1">Aún no tienes organizaciones referidas</span>
              <span class="d-block body-2 text--secondary">Comparte tu enlace para empezar a ganar recompensas.</span>
            </v-col>
            <template v-else>
              <v-data-table :headers="headers" :items="referralsList" :items-per-page="pagination" mobile-breakpoint hide-default-footer hide-default-header disable-sort>
                <!-- header -->
                <template v-slot:header="{ props: { headers } }">
                  <VTableHeaders :headers="headers" @sort="setSort" />
                </template>
                <!-- end header -->
                <template v-slot:[`item.reference`]="{item}">
                  <span class="text--secondary font-weight-medium">{{ item.reference }}</span>
                </template>
                <template v-slot:[`item.granted_at`]="{item}">
                  <span>{{ item.granted_at | date }}</span>
                </template>
                <template v-slot:[`item.bonus`]="{item}">
                  <span class="text--secondary font-weight-medium">{{ item.bonus }}</span>
                </template>
              </v-data-table>
              <v-divider />
              <v-row class="mx-0" align="center">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{ referralsCount }} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </v-row>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import ListViewMixin from '@/mixins/ListViewMixin'
import VTableHeaders from '@/components/VTable/VTableHeaders'
export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    program: {},
    programLoader: false,
    beneficiaryLoader: false,
    selectedBeneficiary: null,
    headers: [
      { text: 'Referencia', value: 'reference', class: 'font-weight-bold', sortable: false },
      { text: 'Nombre de la organización', value: 'referred_account_name', sortable: false },
      { text: 'Fecha de suscripción', value: 'granted_at', sortable: false },
      { text: 'Organización beneficiaria', value: 'beneficiary_account_name', sortable: false },
      { text: 'Estado', value: 'status_display', sortable: false },
      { text: 'Bonus', value: 'bonus', align: 'end', sortable: false }
    ]
  }),
  computed: {
    ...mapState({
      account: state => state.auth.account.id,
      count: state => state.referrals.referralsCount,
      referralsCount: state => state.referrals.referralsCount,
      referralsList: state => state.referrals.referralsList,
      accountsList: state => state.accounts.accountsList
    }),
    rewardLabel () {
      const p = this.program || {}
      if (p.reward_value === undefined || p.reward_value === null) {
        return ''
      }
      if (p.reward_type === '$') {
        return `${p.reward_currency} ${Number(p.reward_value).toLocaleString('es-CL')}`
      }
      return `${p.reward_value}%` // por si el backend vuelve a %
    },
    steps () {
      return [
        {
          title: 'Comparte tu enlace',
          description: 'Envía tu enlace único a quienes quieras contarles sobre Piriod e invitarlos.'
        },
        {
          title: 'Se registran y crean su organización',
          description: 'Será considerado como referido cuando se registre con tu enlace, cree su organización y se suscriba.'
        },
        {
          title: 'Gana tus recompensas',
          description: `Recibirás ${this.rewardLabel} en crédito por cada referido que se convierta en cliente.`
        }
      ]
    }
  },
  created () {
    this.getProgram()

    // load the user organizations for the beneficiary selector
    this.$store.dispatch('accounts/LIST', {
      resource: 'accounts'
    })
  },
  methods: {
    getList () {
      this.$store.dispatch('referrals/LIST', {
        resource: 'referrals',
        query: this.$route.query
      })
    },
    getProgram () {
      this.programLoader = true
      this.$store.dispatch('referrals/GET_PROGRAM')
      .then((response) => {
        this.program = response.data
        this.selectedBeneficiary = response.data.beneficiary_account
      })
      .catch(() => {
        this.$dialog.message.error('No pudimos cargar tu programa de referidos')
      })
      .finally(() => {
        this.programLoader = false
      })
    },
    copyLink () {
      if (!this.program.share_link) {
        return false
      }
      // navigator.clipboard con fallback a $copyText (vue-clipboard2)
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.program.share_link)
        .then(() => { this.$dialog.message.info('Enlace copiado') })
        .catch(() => { this.toClipboard(this.program.share_link) })
      } else {
        this.toClipboard(this.program.share_link)
      }
    },
    changeBeneficiary (accountId) {
      this.beneficiaryLoader = true
      this.$store.dispatch('referrals/PATCH_BENEFICIARY', {
        beneficiary_account: accountId
      })
      .then(() => {
        this.$dialog.message.info('Organización beneficiaria actualizada')
        this.getProgram()
      })
      .catch(() => {
        this.$dialog.message.error('No pudimos actualizar la organización beneficiaria')
        // revert selection to the current program beneficiary
        this.selectedBeneficiary = this.program.beneficiary_account
      })
      .finally(() => {
        this.beneficiaryLoader = false
      })
    }
  }
}
</script>
